import axios from 'axios';

class CityService {
  private static instance: CityService;
  private citiesCache: Map<string, string[]> = new Map();

  private readonly GEO_BASE_URL = '/api/geo';

  private constructor() {}

  public static getInstance(): CityService {
    if (!CityService.instance) {
      CityService.instance = new CityService();
    }
    return CityService.instance;
  }

  public async getCitiesByState(state: string): Promise<string[]> {
    if (this.citiesCache.has(state)) {
      return this.citiesCache.get(state)!;
    }

    try {
      const response = await axios.get<string[]>(
        `${this.GEO_BASE_URL}/v1/city?state=${state}`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      const cities = response.data;
      this.citiesCache.set(state, cities);
      return cities;
    } catch (error) {
      console.error('Error fetching cities:', error);
      return [];
    }
  }

  public clearCache(): void {
    this.citiesCache.clear();
  }
}

export const cityService = CityService.getInstance();

export const getCitiesByState = async (state: string): Promise<string[]> => {
  return cityService.getCitiesByState(state);
};
